import * as React from 'react'

import { type SortDirection, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  sortAttribute: string
  sortDirection: SortDirection
  canSeeAggregatedInfo?: boolean
  onSort: (attribute: string, sortDirection: SortDirection) => void
}

const Header = ({
  sortAttribute,
  sortDirection,
  onSort,
  canSeeAggregatedInfo,
}: Props): JSX.Element | null => {
  return (
    <>
      <Table.SortableHeadCell
        colSpan={1}
        attribute="employeesQuantity"
        onSort={onSort}
        sortAttribute={sortAttribute}
        sortDirection={sortDirection}
      >
        {i18n.t('employees.common.team_members')}
      </Table.SortableHeadCell>
      {canSeeAggregatedInfo && (
        <Table.SortableHeadCell
          colSpan={1}
          attribute="average_age"
          onSort={onSort}
          sortAttribute={sortAttribute}
          sortDirection={sortDirection}
        >
          {i18n.t('employees.common.average_age')}
        </Table.SortableHeadCell>
      )}
      <Table.SortableHeadCell
        colSpan={1}
        attribute="tenure"
        onSort={onSort}
        sortAttribute={sortAttribute}
        sortDirection={sortDirection}
      >
        {i18n.t('employees.common.average_tenure')}
      </Table.SortableHeadCell>
      {canSeeAggregatedInfo && (
        <Table.HeadCell colSpan={1}>
          <Text.Normal weight="medium" size="200" color="grey800">
            {i18n.t('employees.common.gender_distribution')}
          </Text.Normal>
        </Table.HeadCell>
      )}
    </>
  )
}

export default observer(Header)
